import { config } from '../../config'
import { isMainnet } from '../../constants'

export const NETWORK_VERSION = config.networkVersion
export const SIGN_COPY = 'Sign this message to confirm your wallet address:'

const rpcLinksMainnet = {
  ethereum:
    'https://speedy-nodes-nyc.moralis.io/12e1414e704558bcd439c202/eth/mainnet',
  polygon: 'https://polygon-rpc.com/',
  binance: 'https://bsc-dataseed.binance.org/',
  blast: process.env.REACT_APP_BLAST_RPC,
  base: process.env.REACT_APP_BASE_RPC,
  basePrivateRpc: process.env.REACT_APP_BASE_RPC_PRIVATE,
}

const rpcLinksTestnet = {
  ethereum:
    'https://eth-rinkeby.alchemyapi.io/v2/ONGuwDVpCcNki7DeKLi_ScvATp8N8vx4',
  polygon:
    'https://polygon-mumbai.g.alchemy.com/v2/cntlzb4kJT-9BFLrGaSrei-_ZdB6HpkH',
  binance: 'https://data-seed-prebsc-1-s1.binance.org:8545/',
  blast: process.env.REACT_APP_BLAST_RPC,
  base: process.env.REACT_APP_BASE_RPC,
  basePrivateRpc: process.env.REACT_APP_BASE_RPC_PRIVATE,
}

export const BSC_NETWORK = isMainnet
  ? rpcLinksMainnet.binance
  : rpcLinksTestnet.binance

export const ETH_NETWORK = isMainnet
  ? rpcLinksMainnet.ethereum
  : rpcLinksTestnet.ethereum

export const POLYGON_NETWORK = isMainnet
  ? rpcLinksMainnet.polygon
  : rpcLinksTestnet.polygon

export const BLAST_NETWORK = isMainnet
  ? rpcLinksMainnet.blast
  : rpcLinksTestnet.blast

export const BASE_NETWORK = isMainnet
  ? rpcLinksMainnet.base
  : rpcLinksTestnet.base

export const BASE_NETWORK_PRIVATE_RPC = isMainnet
  ? rpcLinksMainnet.basePrivateRpc
  : rpcLinksTestnet.basePrivateRpc

// haha I've just realised how stupid the above code is! will refactor when there's time, it's a conditional that always returns an env var lol, the same env var! So good! Another one of Kamil's "cleanups" that just made things worse

export const POLYGON_NETWORK_ID = Number(
  process.env?.REACT_APP_POLYGON_NETWORK_ID ?? '80001',
)
